export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            overflow="visible"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15ZM8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16Z"
                    fill="currentColor"
                />
                <path
                    d="M8.63 4.04C8.77 4.18 8.83 4.34 8.83 4.54C8.83 4.74 8.76 4.91 8.63 5.04C8.5 5.17 8.33 5.24 8.13 5.24C7.93 5.24 7.76 5.17 7.61 5.04C7.47 4.9 7.41 4.74 7.41 4.54C7.41 4.34 7.48 4.17 7.61 4.04C7.75 3.9 7.93 3.84 8.13 3.84C8.33 3.84 8.5 3.91 8.63 4.04ZM8.63 12H7.62V6.77H8.63V12Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};
